<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.25582 3.30378L4.21682 6.34278C3.82682 6.73378 3.82682 7.36678 4.21682 7.75778C4.60682 8.14778 5.24082 8.14778 5.63082 7.75778L6.97482 6.41378V12.0508C6.97482 12.6018 7.42282 13.0508 7.97482 13.0508C8.52582 13.0508 8.97482 12.6018 8.97482 12.0508V6.41378L10.3178 7.75778C10.7088 8.14778 11.3418 8.14778 11.7328 7.75778C12.1228 7.36678 12.1228 6.73378 11.7328 6.34278L8.69282 3.30378C8.68982 3.29978 8.68582 3.29578 8.68182 3.29278C8.48682 3.09678 8.23082 2.99978 7.97482 2.99978C7.71882 2.99978 7.46282 3.09678 7.26682 3.29278C7.26382 3.29578 7.25982 3.29978 7.25582 3.30378Z"
      fill="currentColor"
    />
  </svg>
</template>
<script>
export default { name: 'ArrowIcon' }
</script>
